<template>
	<div class="container">
		<p>筛选查询</p>
		<div class="container crumbs">
			<div class="handle-search ">
				<e-search :data="formData" :field-list="fieldList" :list-type-info="listTypeInfo" :btnStyle="btnStyle"
					@handleReset="handleClear" @handleFilter="handleQuery"></e-search>
			</div>
		</div>
		<p>日志列表</p>
		<div class="container crumbs">
			<TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" @handleButton="handleButton"
				@handleSortChange="handleSortChange" @handleSelectionChange="handleSelectionChange"></TableList>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="page.pageNum"
					:page-sizes="[10, 20,50, 100, 200]" :page-size="page.pageSize" :total="pageTotal"
					@current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import ESearch from "../../components/common/e-search";
	import TableList from "../../components/common/e-table-list";
	import api from "../../api/logsystem/index";
	export default {
		//   name: "productCatalogExam",
		components: {
			ESearch,
			TableList
		},
		data() {
			return {
				loading: false,
				tableData: [],
				tableLabel: [{
						label: '序号',
						param: "",
						align: 'center',
						width: "100",
					},
					{
						label: "操作类型",
						param: "logType",
						align: "center",
						render: (row) => {
							if (row.logType === "ADD") {
								return "新增人员"
							} else if (row.logType == "MODIFY") {
								return "修改人员"
							} else if (row.logType == "DELETE") {
								return "删除人员"
							}
						}
					},
					{
						label: "角色名称",
						param: "roleName",
						align: "center"
					},
					{
						label: "权限名称",
						param: "authName",
						align: "center"
					},
					{
						label: "操作人",
						param: "operatorRealName",
						align: "center"
					},
					{
						label: "操作时间",
						param: "",
						align: "center"
					},
					{
						label: "IP地址",
						param: "memberIp",
						align: "center"
					}
				],
				//   tableOption: {
				//     label: "操作",
				//     width: "300",
				//     fixed: "right",
				//     options: [
				//       { label: "查看详情", type: "primary", methods: "handleOrderDetail" },
				//       { label: "查看并确认", type: "primary", methods: "handleOrderConfirm" },
				//      ],
				//     flag: true,
				//   },
				fieldList: [{
						label: '操作类型',
						type: 'select',
						value: 'supplierCompanyName',
						list: 'applicationStatus'
					},
					{
						label: '操作人',
						type: 'input',
						value: 'applicationStatus'
					},
					{
						label: '操作时间',
						type: 'date',
						value: 'startTime',
						dateType: 'daterange'
					},
					{
						label: '角色名称',
						type: 'input',
						value: 'CharacterName'
					},
					{
						label: '权限名称',
						type: 'input',
						value: 'jurisdiction'
					},
					{
						label: 'IP地址',
						type: 'input',
						value: 'memberIp'
					}
				],
				listTypeInfo: {
					applicationStatus: [{
							id: "ADD",
							name: '新增人员'
						},
						{
							id: 'MODIFY',
							name: '修改人员'
						},
						{
							id: 'DELETE',
							name: '删除人员'
						},
					],
				},
				btnStyle: [{
						icon: "el-icon-refresh",
						text: "重置"
					},
					{
						icon: "el-icon-search",
						text: "查询",
						type: "primary"
					},
				],
				pageTotal: 0,
				formData: {
					supplierCompanyName: '',
					startTime: '',
					applicationStatus: '',
					CharacterName: "",
					jurisdiction: "",
					memberIp: ""
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					pageStart: 1
				}
			}
		},
		created() {
			this.AccessAoThePaging()
		},
		methods: {
			// handleSearch() {
			//    this.formData.pageNum = 10
			//  },
			//重置
			handleClear() {
				// this.formData.supplierCompanyName=""
				// this.formData.applicationStatus=""
				// this.formData.startTime=""
				// this.formData.loginID=""
				// this.formData.cellPhoneNumber=""
				// this.formData.emailAddress=""
				this.AccessAoThePaging()
			},
			//查询
			handleQuery(val) {
				console.log(val);
				let Query = {
					authName: val.jurisdiction,
					endTime: val.startTime[1],
					logType: val.supplierCompanyName,
					operatorRealName: val.ataapplicationStatus,
					pageStart: this.page.pageStart,
					pageSize: this.page.pageSize,
					roleName: val.CharacterName,
					startTime: val.startTime[0],
					memberIp: val.memberIp
				}
				api.queryAuthorityPage(Query).then((res) => {
					console.log(res)
					this.tableData = res.data.list
					this.pageTotal = res.data.total
				})
			},
			handleButton(val) {
				console.log(val)
			},
			handleSortChange() {},
			handleSelectionChange() {},
			//分页导航
			handlePageChange(val) {
				this.page.pageNum = val
				this.AccessAoThePaging()
			},
			handleSizeChange(pageSize) {
				console.log(pageSize)
				this.page.pageSize = pageSize
				this.AccessAoThePaging()
			},
			async AccessAoThePaging() {
				let res = await api.queryAuthorityPage(this.page)
				console.log(res)
				this.tableData = res.data.list
				this.pageTotal = res.data.total
			}
		}
	}
</script>

<style scoped lang="scss">
	.time {
		::v-deep .el-input {
			width: 80px;
		}
	}
</style>
